import script from "./scrapped.vue?vue&type=script&setup=true&lang=ts"
export * from "./scrapped.vue?vue&type=script&setup=true&lang=ts"

import "./scrapped.vue?vue&type=style&index=0&id=4ded955c&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ded955c"]])

export default __exports__